// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header-3pYsCyzS","user":"user-HxJ1vdqk","topAd_box":"topAd_box-kSUJSi5f","topAd":"topAd-12XqLTmh","search_bar":"search_bar-21c5IRlE","logoAd":"logoAd-2hioX6lg"};